<div class="subheader with-padding flgrow" *ngIf="dealerList && dealerList.length > 0">
  <div class="row">
    <div class="col-sm-4">
      <div class="relative flmid">
        <div class="flgrow">
            <app-dealer-searchbox-dropdown [dealerList]="dealerList" [ngModel]="dealerSelected" [selectedDealer]="dealerSelected"
            ngDefaultControl name="dealerDropdown"
              (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer">
            </app-dealer-searchbox-dropdown>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Edit Parking starts -->
<section class="users-edit container">
  <div class="row">
    <div class="col-12">
      <div class="card mb15">
        <div class="card-header" *ngIf="isView" style="text-transform: none;">
          <h4 class="card-title" translate>lblPleaseSelectTheDealerFromAbove</h4>
        </div>
        <div class="card-content" *ngIf="isData">
          <div class="card-body">
            <form (ngSubmit)="onSubmit()">
              <div class="row">
                <!-- Change Image section start -->
                <div class="col-md-12">
                  <ng-container *ngIf="image; else load_else_template">
                    <img af-image [data-code]="dealerParkingDetails?.imagePath" [data-src]="image" id="UploadImage" alt="Parking image does not found." class="" width="100%">
                  </ng-container>
                  <ng-template #load_else_template>
                    <p translate>lblParkingImageNotFound</p>
                  </ng-template>
                  <div class="mt-3">
                    <div class="mb-2" *ngIf="userRoleRightsDetails.canAdd">
                      <label class="btn btn-outline-primary d-inline-block mb-sm-0 " for="select-files"
                        translate>lblUploadParkingImage</label>
                      <input #fileInput type="file" id="select-files" hidden name="FUImage" accept=".png, .jpg, .jpeg"
                      (click)="fileInput.value = null" (change)="onChangeFileUpload($event.target.files)">
                    </div>
                    <p class="text-muted">
                      <small translate>lblAllowedJPGGIFPNG</small>
                    </p>
                  </div>
                </div>
                <!-- Change Image Section end -->
              </div>
              <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15"  *ngIf="userRoleRightsDetails.canAdd">
                <button type="submit" class="btn btn-primary" aria-label="Center Align" translate><em class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Edit Parking ends -->
